import {
  JbI18nData
} from "./chunk.SE5MQEAG.js";
import {
  Rt
} from "./chunk.LTAMHVKK.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  JBCookie
} from "./chunk.WXNWU2SV.js";
import {
  h,
  ke
} from "./chunk.FCKNEYTX.js";
import {
  n
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.I4IFG4JG.js";

// src/components/jb-market-display/jb-market-display.scss?inline
var jb_market_display_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
span {
  font-family: var(--theme-font-bold-family, VerlagSSm, Tahoma, sans-serif);
  font-weight: var(--theme-font-bold-weight, 700);
}

span {
  color: rgb(var(--rgb-primary, 20, 30, 85));
  font-size: 0.688rem;
  letter-spacing: 0.063rem;
  line-height: 1rem;
}

:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

div {
  align-items: center;
  display: flex;
}

span {
  color: rgba(20, 30, 85, var(--theme-opacity-40, 0.4));
  text-transform: uppercase;
}

.long {
  display: none;
}

@media (min-width: 600px) {
  .short {
    display: none;
  }
  .long {
    display: inline-block;
  }
}`;

// src/components/jb-market-display/jb-market-display.ts
var JbMarketDisplay = class extends h {
  static _readMarketFromCookie() {
    const cookieData = JBCookie.getI18nCookieData();
    const userMarket = parseInt(cookieData.market, 10);
    if (userMarket === 0) {
      return void 0;
    }
    const short = cookieData.country;
    const long = JbI18nData.find()?.getMarketLabel(userMarket) || "";
    return { short, long };
  }
  render() {
    const longMarket = this.staticMarket || JbMarketDisplay._readMarketFromCookie().long || void 0;
    const shortMarket = this.staticMarketShort || JbMarketDisplay._readMarketFromCookie().short || void 0;
    if (longMarket === void 0) {
      return ke``;
    }
    return ke`
      <div class="${Rt({ hasshort: !!shortMarket })}">
        <span class="short">${shortMarket}</span>
        <span class="long">${longMarket}</span>
      </div>
    `;
  }
};
JbMarketDisplay.styles = r(jb_market_display_default);
__decorateClass([
  n()
], JbMarketDisplay.prototype, "staticMarket", 2);
__decorateClass([
  n()
], JbMarketDisplay.prototype, "staticMarketShort", 2);
JbMarketDisplay = __decorateClass([
  customElement("jb-market-display")
], JbMarketDisplay);

export {
  JbMarketDisplay
};
